module.exports = __webpack_public_path__ + "static/media/confirmed-circle-success.575d18f8.svg";